module.exports = "<div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n        <div class=\"alert alert-success\" role=\"alert\" style=\"text-align: center;\">\r\n            <span style=\"font-weight: bold;\">The issue has been created. </span>\r\n            <br />\r\n            <br />\r\n            <span> You will be redirected back to the page in a moment. </span>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/IssueWeb/public/issue-web-confirmation/issue-web-confirmation.component.html
// module id = ./src/app/components/IssueWeb/public/issue-web-confirmation/issue-web-confirmation.component.html
// module chunks = main